import faviconIcoImg from "./favicon/favicon.ico";
import favicon16Img from "./favicon/favicon-16.png";
import favicon32Img from "./favicon/favicon-32.png";
import favicon120Img from "./favicon/favicon-120.png";
import favicon228Img from "./favicon/favicon-228.png";

export function Favicon() {
  return (
    <>
      <link rel="icon" type="image/png" href={favicon16Img.src} sizes="16x16" />
      <link rel="icon" type="image/png" href={favicon32Img.src} sizes="32x32" />
      <link rel="icon" type="image/png" href={favicon120Img.src} sizes="120x120" />
      <link rel="icon" type="image/png" href={favicon228Img.src} sizes="228x228" />
      <link rel="icon" type="image/x-icon" href={faviconIcoImg.src} />
    </>
  );
}
